import { http } from '../../http';

export default {
  getDistricts() {
    return http.get(`/region-compilation`);
  },
};
